export default [
    [
        "#FFFFFF",
        "#E1E1E1",
        "#CCCCCC",
        "#B7B7B7",
        "#A0A0A5",
        "#898989",
        "#707070",
        "#626262",
        "#555555",
        "#464646",
        "#363636",
        "#262626",
        "#1D1D1D",
        "#000000"
    ],
    [
        "#F4977C",
        "#F7AC84",
        "#FBC58D",
        "#FFF69E",
        "#C4DE9E",
        "#85C99E",
        "#7FCDC7",
        "#75D0F4",
        "#81A8D7",
        "#8594C8",
        "#8983BC",
        "#A187BD",
        "#BB8DBE",
        "#F29BC1"
    ],
    [
        "#EF6C53",
        "#F38D5B",
        "#F8AE63",
        "#FFF371",
        "#ACD277",
        "#43B77A",
        "#2EBBB3",
        "#00BFF0",
        "#4A8DC8",
        "#5875B7",
        "#625DA6",
        "#8561A7",
        "#A665A7",
        "#EE6FA9"
    ],
    [
        "#EA1D2C",
        "#EE652E",
        "#F4932F",
        "#FFF126",
        "#8EC648",
        "#00A553",
        "#00A99C",
        "#00AFED",
        "#0073BA",
        "#0056A4",
        "#323390",
        "#66308F",
        "#912A8E",
        "#E9088C"
    ],
    [
        "#9B0B16",
        "#9E4117",
        "#A16118",
        "#C6B920",
        "#5A852D",
        "#007238",
        "#00746A",
        "#0077A1",
        "#004C7F",
        "#003570",
        "#1D1762",
        "#441261",
        "#62095F",
        "#9C005D"
    ],
    [
        "#770001",
        "#792E03",
        "#7B4906",
        "#817A0B",
        "#41661E",
        "#005827",
        "#005951",
        "#003B5C",
        "#001D40",
        "#000E35",
        "#04002C",
        "#19002B",
        "#2C002A",
        "#580028"
    ],
];
